import { render, staticRenderFns } from "./SpiritPage.vue?vue&type=template&id=effd0d2c&scoped=true"
import script from "./SpiritPage.vue?vue&type=script&lang=js"
export * from "./SpiritPage.vue?vue&type=script&lang=js"
import style0 from "./SpiritPage.vue?vue&type=style&index=0&id=effd0d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effd0d2c",
  null
  
)

export default component.exports